import { menuService } from "./index";

export const completeRegister = (user_name, password) => {
  return menuService.post("/retailer/register", { user_name, password });
};
export const authenticateBasic = (user_name, password) => {
  return menuService.post("/retailer/login", { user_name, password });
};
export const resetPassword = (email) => {
  return menuService.post("/retailer/forgot-password", { email });
};
export const updatePassword = (reset, password) => {
  return menuService.post("/retailer/update-password", { reset, password });
};
export const getUser = () => {
  return menuService.get("/retailer/auth");
};
